import './AutocompleteField.css';
import React from 'react';
import { useHistory } from "react-router-dom";
import addQueryString from "./index";
import { qsToObject } from "../../utils/querystring";
import { canUseDOM } from '../../utils';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
const SuggestionsList = _ref => {
  let {
    suggestionList,
    setIsOpen
  } = _ref;
  const drop = React.useRef(null);
  const handleOutClick = _ref2 => {
    let {
      target
    } = _ref2;
    if (!target.closest(`.${drop.current.className}`)) {
      setIsOpen(false);
    }
  };
  const handleItemClick = title => {
    setIsOpen(false);
  };
  React.useEffect(() => {
    if (canUseDOM) {
      document.body.addEventListener('click', handleOutClick);
      return () => document.body.removeEventListener('click', handleOutClick);
    }
  }, []);
  return /*#__PURE__*/React.createElement("ul", {
    className: "suggestions-list autocomplete",
    ref: drop
  }, suggestionList.map(suggestion => {
    return /*#__PURE__*/React.createElement("li", {
      className: "suggestion-item",
      onClick: () => handleItemClick(suggestion.title)
    }, /*#__PURE__*/React.createElement("a", {
      href: suggestion.url
    }, suggestion.title));
  }));
};
const AutocompleteField = _ref3 => {
  let {
    setFilter,
    facetsName,
    hits = [],
    placeholder
  } = _ref3;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  let history = useHistory();
  const [firstRender, setFirstRender] = React.useState(true);
  const [isOpen, setIsOpen] = React.useState(false);
  const borderRadius = {
    borderRadius: '4px 4px 0 0'
  };
  const [value, setValue] = React.useState('');
  const handleOnChange = event => {
    setIsOpen(true);
    setValue(event.target.value);
  };
  React.useEffect(() => {
    if (!firstRender) {
      const timeoutId = setTimeout(() => setFilter(value), 500);
      return () => clearTimeout(timeoutId);
    } else {
      setFirstRender(false);
    }
  }, [value]);
  const sendRequestHandler = title => {
    setValue(title);
    addQueryString(facetsName, title, history);
    setFilter(title);
  };
  React.useEffect(() => {
    const urlParams = qsToObject(window.location.href);
    const title = urlParams['title'];
    if (title) {
      setValue(title.split('+').join(' '));
    }
  }, []);
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter__field "
  }, /*#__PURE__*/React.createElement("div", {
    className: "input-search-box"
  }, /*#__PURE__*/React.createElement("input", {
    type: "text",
    className: "input-search-text",
    placeholder: placeholder,
    style: isOpen && hits.length ? borderRadius : undefined,
    value: value,
    onChange: handleOnChange,
    onClick: () => setIsOpen(true)
  }), /*#__PURE__*/React.createElement("span", {
    className: "search-icon"
  })), isOpen && /*#__PURE__*/React.createElement(SuggestionsList, {
    suggestionList: hits,
    setIsOpen: setIsOpen,
    sendRequestHandler: sendRequestHandler
  })));
};
const StyledWrapper = _ref4 => {
  let {
    children,
    rtl
  } = _ref4;
  return /*#__PURE__*/React.createElement("div", {
    className: `${commonStyles} ${rtl ? rtlStyles : ''}`
  }, children);
};

// export default DropDown;
export default AutocompleteField;
const commonStyles = "c1liztjw";
const rtlStyles = "r4sot6y";